import { Component, input, output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterAccountSite,
  TFilterAccountSiteOptions,
} from '../../../../models/advanced-filter.model';
import { accountSiteOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-account-sites',
  templateUrl: './advanced-filter-account-sites.component.html',
  styleUrl: './advanced-filter-account-sites.component.scss',
  standalone: false,
})
export class AdvancedFilterAccountSitesComponent {
  ppFilter = input<TAdvancedFilterAccountSite>();
  ppFilterChange = output<TAdvancedFilterAccountSite>();

  values: string[];
  option: TFilterAccountSiteOptions;
  filter: TAdvancedFilterAccountSite;

  advancedFilterAccountSiteOperatorOptions = accountSiteOperatorOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;
  selectedAccountSites: string[];

  ngOnChanges(): void {
    this.filter = this.ppFilter() as TAdvancedFilterAccountSite;

    this.values = this.filter.value;
    this.selectedAccountSites = this.values;
    this.option = this.filter.option;
  }

  applyAccountSitesFilters(values: string[]): void {
    this.ppFilter().value = values;
    this.ppFilter().id = 'workspaceRef.id';

    this.applyChanges();
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter().option = newCondition.value as TFilterAccountSiteOptions;
    this.option = newCondition.value as TFilterAccountSiteOptions;

    this.ppFilter().operator = newCondition.operator;

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter());
  }

  changeFieldValue(values: string[]): void {
    this.ppFilter().value = values;
    this.applyChanges();
  }
}
